import React, { useState, useEffect } from "react";
import { Row, InputGroup, Form } from "react-bootstrap";
import { CCol, CFormLabel, CFormFeedback, CFormInput } from "@coreui/react";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import { ToastContainer } from "react-toastify";

import PageWrapper from "../../pagecomponents/Common/PageWrapper";
import JobReport from "../../pages/Job-new/Report";

import { listJob, deleteJob, getJobById as fetchJobById } from "../../redux/slices/JobSlice";
import { getMasterData } from "../../redux/slices/CustomerSlice";
import { toastMessage } from "../../helpers/utility";
import ModalWrapper from "../../pagecomponents/Common/ModalWrapper";
import JobAddEdit from "./AddEditForm";
import CustomerAddEdit from "../masters/customer/AddEditForm";
import Swal from "sweetalert2";
import { format } from "date-fns";
import useDebouncedValue from "../../helpers/useDebouncedValue";

const JobIndex = () => {
    const pageName = "Job";
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);

    const PARAMS = {
        skip: 0,
        take: rowsPerPage,
        type: "",
        sorting: 'desc',
        sorting_key: 'created_at',
        filter: {
            fromdate:"",
            todate:"",
            job_Id: "",
            customer_Code : "",
            customer_Name : "",
            doc_No:"",
            job_No:"",
            payment_Type: "",
            invoice_Status: "",
        }
    };

    const [data, setData] = useState([]);
    const [editData, setEditData] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [params, setParams] = useState(PARAMS);
    const [textFilters, setTextFilters] = useState({
        customer_Code: "",
        customer_Name: "",
        job_No: "",
        doc_No: "",
    });
    const debouncedTextFilters = useDebouncedValue(textFilters, 400);

    const [isLoading, setIsLoading] = useState(false);
    const [filterSectionVisible, setFilterSectionVisible] = useState(false);
    const [jobAddEditModalVisible, setJobAddEditModalVisible] = useState(false);
    const [customerModalVisible, setCustomerModalVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    // const [customerAddModalVisible, setCustomerAddModalVisible] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);

    useEffect(() => {
        getJobList();
    }, [params]);

    useEffect(() => {
        setCurrentPage(1);
        setParams((prev) => {
            const prevFilter = prev?.filter || {};
            const isSameFilter =
                String(prevFilter.customer_Code || "") === debouncedTextFilters.customer_Code &&
                String(prevFilter.customer_Name || "") === debouncedTextFilters.customer_Name &&
                String(prevFilter.job_No || "") === debouncedTextFilters.job_No &&
                String(prevFilter.doc_No || "") === debouncedTextFilters.doc_No;

            if (isSameFilter && prev.skip === 0) {
                return prev;
            }

            return {
                ...prev,
                skip: 0,
                filter: {
                    ...prevFilter,
                    ...debouncedTextFilters,
                },
            };
        });
    }, [debouncedTextFilters]);

    useEffect(() => {
        fetchMasterData();
    }, []);

    const getJobList = async() => {
        closeModal();
        setIsLoading(true);
        setIsSaveDisabled(true);
                
        try {
            const { payload } = await dispatch(listJob({ inputData: params }));
            setData(payload.data);
            setTotalPage(Math.ceil(payload.count/rowsPerPage));
            return payload;
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
            return null;
        } finally {
            setIsLoading(false); // Stop loader
            setIsSaveDisabled(false);
        }
    };

    const getJobDetails = async(job_Id) => {
        if (!job_Id) return null;

        try {
            const { payload } = await dispatch(
                fetchJobById({
                    inputData: {
                        job_Id,
                    },
                })
            );

            return payload?.data?.[0] || null;
        } catch (err) {
            toastMessage("error", "Failed to fetch job details");
            return null;
        }
    };

    const fetchMasterData = async() => {
        let PARAMS = {};
        const { payload } = await dispatch(getMasterData({ inputData: PARAMS }));
        if (payload?.status === "error") {
            console.error("Error fetching data:", payload.msg);
        } else {
            // console.log(payload.payment_mode);
            setMasterData(payload);
        }
    };

    const openAddModal = () => {
        setJobAddEditModalVisible(true);
        setIsEdit(false);
    };

    const openEditModal = async(item) => {
        const refreshedItem = await getJobDetails(item?.job_Id);
        if (!refreshedItem) return;

        setJobAddEditModalVisible(true);
        setIsEdit(true);
        setEditData(refreshedItem);
    };

    const closeModal = () => {
        setJobAddEditModalVisible(false);
    };

    const handleDelete = async(job_Id) => {
        const jobData = await getJobDetails(job_Id);
        if (!jobData) {
            toastMessage("error", "Job not found. Please refresh and try again.");
            return;
        }

        const { payload } = await dispatch(deleteJob({ inputData: { job_Id: job_Id, type: "delete" } }));
        if (payload?.status === "error") {
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            // toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");
            await getJobList();
            // closeModal();
            // setDeleteAlertVisible(false);
        }
    };

    // const handleSort = (key) => {
    //     setParams((prev) => ({
    //         ...prev,
    //         sorting_key: key,
    //         sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    //     }));
    // };

    const handleSort = (key) => {
        setCurrentPage(1);
        
        setParams((prev) => ({
            ...prev,
            skip: 0,
            sorting_key: key,
            sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
        }));
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
        
        setParams((prev) => ({
          ...prev,
          take: rows,
          skip: 0,
        }));
    };

    const setPage = (pagenum) => {
        setCurrentPage(pagenum);
        setParams((prev) => ({
            ...prev,
            skip: (pagenum - 1) * prev.take,
        }));
    };

    const toogleFilterSection = () => {
        setFilterSectionVisible((prev) => !prev);
    };

    const handleFilterParamsOnChange = (e, dateField = null, date = null) => {
        if (dateField) {
            setParams((prev) => ({
                ...prev,
                filter: {
                    ...prev.filter,
                    [dateField]: date ? format(new Date(date), "yyyy-MM-dd") : "" // Convert date to 'YYYY-MM-DD'
                }
            }));
        } else {
            const { name, value } = e.target;
            if (["customer_Code", "customer_Name", "job_No", "doc_No"].includes(name)) {
                setTextFilters((prev) => ({
                    ...prev,
                    [name]: value,
                }));
                return;
            }
            setParams((prev) => ({
                ...prev,
                filter: {
                    ...prev.filter,
                    [name]: value
                }
            }));
        }
    };


    const toogleCustomerModal = () => {
        setCustomerModalVisible((prev) => !prev);
    };
    
    const columns = [
        {label: "#", accessor: "index", sortable: false},
        {label: "Job Date", accessor: "job_Date", sortable: true},
        {label: "Job No", accessor: "job_No", sortable: true},
        {label: "Customer Name", accessor: "customer_Name", sortable: true},
        {label: "Doc No", accessor: "doc_No", sortable: true},
        {label: "No of Lead", accessor: "job_Load_No", sortable: true},
        {label: "Rate", accessor: "rate", sortable: true},
        {label: "Amount", accessor: "jobChargeTotalAmount", sortable: true},
        {label: "Paid By", accessor: "payment_Type_Name", sortable: true},
        {label: "Bill Status", accessor: "invoice_Id", sortable: true},
    ];

    return(
        <>
            <ToastContainer />
            <PageWrapper
                pageName={pageName}
                headerBtnTitle="+ Job"
                onHeaderButtonClick={() => {openAddModal()}}
                showFilterBtn={true}
                onFilterBtnClick={() => toogleFilterSection()}
                filterBtnTitle={filterSectionVisible ? 'Hide Filter' : 'Show Filter'}
                showAddBtn={true}
            >
                {filterSectionVisible && (
                    <Row className="row-sm mb-3">
                        {/* <CCol md={2}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Code">Cust. Code</CFormLabel>
                            <CFormInput
                                type="text"
                                id="customer_Code"
                                name="customer_Code"
                                value={params.filter.customer_Code}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol> */}
                        <CCol md={4}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Name">Cust. Name</CFormLabel>
                            <CFormInput
                                type="text"
                                id="customer_Name"
                                name="customer_Name"
                                value={textFilters.customer_Name}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        <CCol md={4}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="fromdate">From</CFormLabel>
                            <InputGroup className="input-group reactdate-pic">
                                <InputGroup.Text className="input-group-text">
                                    <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                                </InputGroup.Text>
                                {/* <DatePicker
                                    className="form-control"
                                    name="fromdate"
                                    id="fromdate"
                                    value={params.filter.fromdate}
                                    onChange={handleFilterParamsOnChange}
                                /> */}
                                <DatePicker
                                    className="form-control"
                                    name="fromdate"
                                    id="fromdate"
                                    selected={params.filter.fromdate ? new Date(params.filter.fromdate) : null} // Convert string to Date object
                                    onChange={(date) => handleFilterParamsOnChange(null, "fromdate", date)}
                                    dateFormat="yyyy-MM-dd"
                                />
                            </InputGroup>
                            <CFormFeedback invalid>Select From Date</CFormFeedback>
                        </CCol>
                        <CCol md={4}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="todate">Until</CFormLabel>
                            <InputGroup className="input-group reactdate-pic">
                                <InputGroup.Text className="input-group-text">
                                    <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                                </InputGroup.Text>
                                {/* <DatePicker
                                    className="form-control"
                                    name="todate"
                                    id="todate"
                                    value={params.filter.todate}
                                    onChange={handleFilterParamsOnChange}
                                /> */}
                                <DatePicker
                                    className="form-control"
                                    name="todate"
                                    id="todate"
                                    selected={params.filter.todate ? new Date(params.filter.todate) : null} // Convert string to Date object
                                    onChange={(date) => handleFilterParamsOnChange(null, "todate", date)}
                                    dateFormat="yyyy-MM-dd"
                                />
                            </InputGroup>
                            <CFormFeedback invalid>Select To Date</CFormFeedback>
                        </CCol>
                        <CCol md={3}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_No">Job No</CFormLabel>
                            <CFormInput
                                type="text"
                                id="job_No"
                                name="job_No"
                                value={textFilters.job_No}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        <CCol md={3}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="doc_No">Doc No</CFormLabel>
                            <CFormInput
                                type="text"
                                id="doc_No"
                                name="doc_No"
                                value={textFilters.doc_No}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        <CCol md={3}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="payment_Type">Paid By</CFormLabel>
                            <Form.Select
                                className="form-control"
                                value={params.filter.payment_Type}
                                onChange={handleFilterParamsOnChange}
                                id="payment_Type"
                                name="payment_Type"
                                // required
                            >
                                <option value="">All</option>
                                {/* Map over the options array to generate the option elements dynamically */}
                                {masterData.payment_mode?.map((option) => (
                                <option key={option.payment_mode_master_Id} value={option.payment_mode_Code}>
                                    {option.payment_mode_Name}
                                </option>
                                ))}
                            </Form.Select>
                            <CFormFeedback invalid>Select Paid By</CFormFeedback>
                        </CCol>
                        <CCol md={3}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="invoice_Status">Bill</CFormLabel>
                            <Form.Select
                                className="form-control"
                                value={params.filter.invoice_Status}
                                onChange={handleFilterParamsOnChange}
                                id="invoice_Status"
                                name="invoice_Status"
                                // required
                            >
                                <option value="">All</option>
                                <option value="1">Done</option>
                                <option value="0">Pending</option>
                            </Form.Select>
                            <CFormFeedback invalid>Select Paid By</CFormFeedback>
                        </CCol>
                    </Row>
                )}

                <JobReport 
                    columns={columns} 
                    data={data} 
                    onEdit={openEditModal}
                    onDelete={handleDelete}
                    onSorting={handleSort}
                    sortingState={{ key: params.sorting_key, order: params.sorting }}
                    currentPage={currentPage}
                    totalPages={totalPage}
                    rowsPerPage={rowsPerPage}
                    updateRowsPerPage={handleRowsPerPageChange}
                    onPageChange={setPage}
                    loader={isLoading}
                />

                <ModalWrapper
                    modalSize="lg"
                    visible={jobAddEditModalVisible}
                    onClose={closeModal}
                    modalTitle={`${isEdit ? "Edit" : "Add"} ${pageName}`}
                >
                    <JobAddEdit 
                        onSave={getJobList}
                        addCustomerModal={toogleCustomerModal} 
                        mode={isEdit}
                        data={editData}
                        isSaveDisabled={isSaveDisabled}
                    />
                </ModalWrapper>


                <ModalWrapper
                    modalSize="lg"
                    visible={customerModalVisible}
                    onClose={toogleCustomerModal}
                    modalTitle="Add Customer"
                >
                    <CustomerAddEdit 
                        onSave={toogleCustomerModal} 
                        section="Job"
                    />
                </ModalWrapper>
            </PageWrapper>
        </>
    );
};

export default JobIndex;
